$(document).ready(function (e) {
  if ($(".field.dependencies-field").length > 0) {
    $(".field.dependencies-field").each(function () {
      // Fetch the conditions from our DOM element
      // Note we get dom.parent() to accommodate conditions attached to the top-level .field element
      var dom = $(this);
      var dependents = dom.find("[data-dependents]").attr("data-dependents");

      var fieldsToReset = dom
        .find("[data-fields-to-reset]")
        .attr("data-fields-to-reset");

      if (fieldsToReset && fieldsToReset !== "") {
        fieldsToReset = JSON.parse(fieldsToReset);
      }

      // Decode our dependents config
      if (dependents && dependents !== "") {
        dependents = JSON.parse(dependents);

        // No valid data, so we can just stop here
        // This has a nice bonus of not binding any events for leaner performance
      } else {
        return;
      }

      // Listen to changes to our dependant field input(s)
      // dom.find('select').on('change', function(e){
      // 	check(e.target.value);
      // 	addressWrapperShow(e.target.value);
      // });

      dom.find("input, textarea, select").on("input", function (e) {
        check(e.target.value);
        resetFields();
        if (dom.hasClass("profile_type")) {
          addressWrapperShow(e.target.value);
        }
      });

      // Check on render
      var initial_value = null;
      if (dom.hasClass("checkbox") || dom.hasClass("optionset")) {
        initial_value = dom.find("input:checked").val();
      } else {
        initial_value = dom.find("input, select").val();
      }
      check(initial_value);

      if (dom.hasClass("profile_type") && initial_value) {
        addressWrapperShow(initial_value);
      }

      function addressWrapperShow(value) {
        $(".address-components-wrapper").removeClass("hide");
        if (value == "LotDP") {
          $(document)
            .find('[name="street_number"]')
            .first()
            .prop("required", false);
          $(document)
            .find('[for="Form_Form_street_number"]')
            .first()
            .text("Street number");
        } else {
          $(document)
            .find('[name="street_number"]')
            .first()
            .prop("required", true);
          $(document)
            .find('[for="Form_Form_street_number"]')
            .first()
            .text("Street number*");
        }
      }

      function resetFields() {
        $.each(fieldsToReset, function (id, value) {
          $(document)
            .find('[name="' + value + '"]')
            .each(function () {
              switch (this.type) {
                case "select":
                  if ($(this).prop("selectedIndex") != -1) {
                    $(this).prop("selectedIndex", -1).trigger("input");
                  }
                  break;
                case "checkbox":
                case "radio":
                  if ($(this).prop("checked") != false) {
                    $(this).prop("checked", false).trigger("input");
                  }
                  break;
                default:
                  if ($(this).val() != "") {
                    $(this).val("").trigger("input");
                  }
                  break;
              }
            });
        });
      }

      /**
       * Run a check on the conditional field
       * We look at the dependant field and it's values to define visiability of our conditional field
       *
       * @param value String
       **/
      function check(value) {
        // Loop all our dependents (JSON objects)
        $.each(dependents, function (id, values) {
          // Find by input name
          var dependent = $(document).find('[name="' + id + '"]');
          if (dependent.length > 0) {
            dependent = dependent.closest(".field");

            // Find by field classname
          } else {
            dependent = $(document).find(".field." + id);
          }

          // No values? Hide the dependent
          if (!values || values == "") {
            dependent.hide();
          }

          // Make sure we're working with an array
          // This allows us to accept singular strings or a JSON array
          if (!Array.isArray(values)) {
            values = values.split(",");
          }

          // Our field's value is included in this dependent's values array
          // So we show it
          if (values.indexOf(value) >= 0) {
            dependent.show();

            // Not present, so hide 'em'
          } else {
            dependent.hide();
          }
        });
      }
    });
  }
});
